// src/constants/bannerConstants.js
const BANNER_CONSTANTS = {
  CREATE_BANNER_REQUEST: 'CREATE_BANNER_REQUEST',
  CREATE_BANNER_SUCCESS: 'CREATE_BANNER_SUCCESS',
  CREATE_BANNER_FAIL: 'CREATE_BANNER_FAIL',
  CREATE_BANNER_RESET: 'CREATE_BANNER_RESET',

  GET_BANNERS_REQUEST: 'GET_BANNERS_REQUEST',
  GET_BANNERS_SUCCESS: 'GET_BANNERS_SUCCESS',
  GET_BANNERS_FAIL: 'GET_BANNERS_FAIL',
  GET_BANNERS_RESET: 'GET_BANNERS_RESET',

  DELETE_BANNER_REQUEST: 'DELETE_BANNER_REQUEST',
  DELETE_BANNER_SUCCESS: 'DELETE_BANNER_SUCCESS',
  DELETE_BANNER_FAIL: 'DELETE_BANNER_FAIL',
  DELETE_BANNER_RESET: 'DELETE_BANNER_RESET',
}
export default BANNER_CONSTANTS
